import AggregateAdjustment from './AggregateAdjustment';
import BuyerCreditFromSeller from './BuyerCreditFromSeller';
import BuyerCreditFromThirdParty from './BuyerCreditFromThirdParty';
import BuyerDeposit from './BuyerDeposit';
import BuyerReimbursementFromSeller from './BuyerReimbursementFromSeller';
import BuyerReimbursementOtherFromSeller from './BuyerReimbursementOtherFromSeller';
import BuyerReimbursementOtherToSeller from './BuyerReimbursementOtherToSeller';
import BuyerReimbursementToSeller from './BuyerReimbursementToSeller';
import BuyerReimbursementToThirdParty from './BuyerReimbursementToThirdParty';
import { Endorsement } from './Endorsement';
import EscrowAtClosing from './EscrowAtClosing';
import EscrowAtClosingOther from './EscrowAtClosingOther';
import ExistingLoanAssumed from './ExistingLoanAssumed';
import HOAFee from './HOAFee';
import InterestPrepayment from './InterestPrepayment';
import LenderCredit from './LenderCredit';
import LoanAmount from './LoanAmount';
import NonInterestPrepayment from './NonInterestPrepayment';
import OriginationFeeOther from './OriginationFeeOther';
import OtherFee from './OtherFee';
import OtherLoanCost from './OtherLoanCost';
import Payoff from './Payoff';
import PercentageOfInterest from './PercentageOfInterest';
import PersonalPropertySale from './PersonalPropertySale';
import PrepaymentOther from './PrepaymentOther';
import PropertyTaxes from './PropertyTaxes';
import RecordingFee from './RecordingFee';
import SalePriceOfProperty from './SalePriceOfProperty';
import { SalesTax } from './SalesTax';
import SellerCredit from './SellerCredit';
import SellerExcessDeposit from './SellerExcessDeposit';
import Tax from './Tax';
import TaxOther from './TaxOther';
import { TitleFee } from './TitleFee';
import { AppraisalFee } from './AppraisalFee';
import { ICDV3ViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { eCDV3ItemTypes } from '../../../ui-toolkit/enums/eCDV3ItemTypes';

const mapItemToItemComponent = (item: ICDV3ViewItem) => {
  // This switch statement is now exhaustive. The return value will have a type error if you add a type and don't add it to this switch statement.
  switch (item.type) {
    // A.
    case eCDV3ItemTypes.percentage_of_loan_amount:
      return PercentageOfInterest;
    case eCDV3ItemTypes.origination_fee_other:
      return OriginationFeeOther;

    // B. & C. & H.
    case eCDV3ItemTypes.endorsement:
    case eCDV3ItemTypes.endorsement_other:
      return Endorsement;
    case eCDV3ItemTypes.title_fee:
    case eCDV3ItemTypes.title_fee_other:
      return TitleFee;
    case eCDV3ItemTypes.other_loan_cost:
      return OtherLoanCost;
    case eCDV3ItemTypes.sales_tax:
      return SalesTax;
    case eCDV3ItemTypes.appraisal_fee:
      return AppraisalFee;

    // E.
    case eCDV3ItemTypes.recording_fee:
    case eCDV3ItemTypes.recording_fee_other:
      return RecordingFee;
    case eCDV3ItemTypes.tax:
      return Tax;
    case eCDV3ItemTypes.tax_other:
      return TaxOther;
    // F.
    case eCDV3ItemTypes.non_interest_prepayment:
      return NonInterestPrepayment;
    case eCDV3ItemTypes.interest_prepayment:
      return InterestPrepayment;
    case eCDV3ItemTypes.prepayment_other:
      return PrepaymentOther;
    // G.
    case eCDV3ItemTypes.escrow_at_closing:
      return EscrowAtClosing;
    case eCDV3ItemTypes.escrow_at_closing_other:
      return EscrowAtClosingOther;
    case eCDV3ItemTypes.aggregate_adjustment:
      return AggregateAdjustment;
    // H.
    case eCDV3ItemTypes.other_fee:
      return OtherFee;
    // J.
    case eCDV3ItemTypes.lender_credit:
      return LenderCredit;
    // Payoffs & Payments
    case eCDV3ItemTypes.payoff:
      return Payoff;
    // K. & L. & M. & N.
    case eCDV3ItemTypes.sale_price_of_property:
      return SalePriceOfProperty;
    case eCDV3ItemTypes.personal_property_sale:
      return PersonalPropertySale;
    case eCDV3ItemTypes.buyer_deposit:
      return BuyerDeposit;
    case eCDV3ItemTypes.loan_amount:
      return LoanAmount;
    case eCDV3ItemTypes.existing_loans_assumed:
      return ExistingLoanAssumed;
    case eCDV3ItemTypes.seller_credit:
      return SellerCredit;
    case eCDV3ItemTypes.seller_excess_deposit:
      return SellerExcessDeposit;
    case eCDV3ItemTypes.buyer_credit_from_seller:
      return BuyerCreditFromSeller;
    case eCDV3ItemTypes.buyer_credit_from_third_party:
      return BuyerCreditFromThirdParty;
    case eCDV3ItemTypes.buyer_reimbursement_to_seller:
      return BuyerReimbursementToSeller;
    case eCDV3ItemTypes.buyer_reimbursement_other_to_seller:
      return BuyerReimbursementOtherToSeller;
    case eCDV3ItemTypes.buyer_reimbursement_from_seller:
      return BuyerReimbursementFromSeller;
    case eCDV3ItemTypes.buyer_reimbursement_other_from_seller:
      return BuyerReimbursementOtherFromSeller;
    case eCDV3ItemTypes.buyer_reimbursement_to_third_party:
      return BuyerReimbursementToThirdParty;
    case eCDV3ItemTypes.hoa_fee:
      return HOAFee;
    case eCDV3ItemTypes.property_taxes:
      return PropertyTaxes;
    // no default
  }
};
export default mapItemToItemComponent;
